import { Component, OnDestroy, OnInit } from '@angular/core';
import { InAppBrowser } from '@capgo/inappbrowser';
import { Platform } from '@ionic/angular';
import { List } from '@models/list';
import { SagaSettingsService } from '@services/settings';
import { WindowOpenerService } from '@services/window-opener/window-opener.service';
import { Subscription } from 'rxjs';
import { IDocumentItem } from '../../interfaces/IDocumentItem';
import { DocumentsService } from '../../services/documents/documents.service';

@Component({
  selector: 'app-documents-view',
  templateUrl: './documents-view.component.html',
  styleUrls: ['./documents-view.component.scss']
})
export class DocumentsViewComponent implements OnInit, OnDestroy {
  error = null;
  isLoading = false;

  folderPath: IDocumentItem[] = [];
  documentsFolder: List<IDocumentItem> = new List<IDocumentItem>();

  private documents: IDocumentItem[] = [];
  private filter: string;

  private getDocumentsSub: Subscription = null;

  get isEmpty(): boolean {
    return this.documents.length === 0 && !this.isLoading && this.error === null;
  }

  private useInappBrowser: boolean = false;

  constructor(
    private documentsService: DocumentsService,
    private sagaSettings: SagaSettingsService,
    private windowOpener: WindowOpenerService,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.useInappBrowser = this.sagaSettings.getValue('SagaMobileWebClient.UseInAppBrowser');
    this.documentsFolder.addFilter(document => new RegExp(this.filter, 'i').test(document.name));

    this.isLoading = true;
    this.getDocumentsSub = this.documentsService.getDocuments().subscribe((documents: IDocumentItem[]) => {
      this.isLoading = false;
      this.documents = documents;
      this.documentsFolder.source = documents;

      this.getDocumentsSub = null;
    }, this.handleError.bind(this));
  }

  private handleError(res) {
    this.isLoading = false;
    this.error = res;
    this.getDocumentsSub = null;
  }

  ngOnDestroy() {
    this.getDocumentsSub?.unsubscribe();
    this.getDocumentsSub = null;
  }

  openRoot() {
    this.folderPath.length = 0;
    this.documentsFolder.source = this.documents;
  }

  openDocument(document: IDocumentItem) {
    if (document.children) {
      this.openFolder(document);
    } else {
      if (this.platform.is('cordova') && this.useInappBrowser) {
        InAppBrowser.openWebView({ url: document.url, title: '' });
      } else {
        this.windowOpener.system(document.url);
      }
    }
  }

  openFolder(folder: IDocumentItem) {
    const folderIndex: number = this.folderPath.indexOf(folder);
    if (folderIndex >= 0) {
      this.folderPath.splice(folderIndex, this.folderPath.length - folderIndex);
    }

    this.folderPath.push(folder);
    this.documentsFolder.source = folder.children;
  }

  filterDocuments(query: string) {
    this.filter = query ? query.trim() : '';
    this.documentsFolder.refresh();
  }
}
